import { createDraftSafeSelector, createSlice } from '@reduxjs/toolkit';

import { logout } from 'store/entities/users/slice';

const initialState = {
  masterDashboardProjects: {
    group: null,
    projects: [],
  },
};

export const dashboardSlice = createSlice({
  name: 'dashboardSlice',
  initialState,
  reducers: {
    setMasterDashboardProjectsAction: (state, action) => ({
      ...state,
      masterDashboardProjects: {
        ...state.masterDashboardProjects,
        ...action.payload,
      },
    }),
    resetMasterDashboardProjectsAction: (state) => ({
      ...state,
      masterDashboardProjects: {
        group: null,
        projects: [],
      },
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { setMasterDashboardProjectsAction, resetMasterDashboardProjectsAction } = dashboardSlice.actions;

export const masterDashboardProjectsGroupSelector = createDraftSafeSelector(
  (state) => state[dashboardSlice.name],
  ({ masterDashboardProjects }) => masterDashboardProjects.group,
);

export const masterDashboardProjectsListSelector = createDraftSafeSelector(
  (state) => state[dashboardSlice.name],
  ({ masterDashboardProjects }) => masterDashboardProjects.projects,
);
